import { Fab, Typography } from '@mui/material'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import useAccount from '@/presentation/hooks/auth/use-account'
import { i18nTranslationHelper } from '@/i18n'

const WhatsAppButton = () => {
  const t = i18nTranslationHelper.getTComponents

  const WHATSAPP_PHONE = '551150265266'
  const WHATSAPP_MESSAGE = t('footer.whatsappMessage')

  const [account] = useAccount()

  if (!account?.helpCenterConfig?.hasWhatsApp) return null

  const handleClick = () => {
    const url = `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`
    window.open(url, '_blank')
  }

  return (
    <Fab
      sx={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        backgroundColor: '#25D366',
        color: '#FFFFFF',
        '&:hover': {
          backgroundColor: '#20b858'
        }
      }}
      aria-label="whatsapp help button"
      onClick={handleClick}
      variant="extended"
      size="medium"
    >
      <WhatsAppIcon />

      <Typography fontWeight={700} textTransform={'none'}>
        {t('footer.helpTitle')}
      </Typography>
    </Fab>
  )
}

export default WhatsAppButton
